<?xml version="1.0" encoding="UTF-8"?>
<svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Design-resize-0.7" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
    <g id="Documents-1-0.7-Almost-Due-Period" transform="translate(-1674.000000, -434.000000)">
      <g id="Group-9" transform="translate(1674.700000, 434.000000)">
        <g id="Group-6" fill="#FF9842">
          <circle id="Oval" cx="8" cy="8" r="8"></circle>
        </g>
        <g id="Group-8" transform="translate(7.000000, 4.000000)" fill="#FFFFFF">
          <rect id="Rectangle" x="0" y="0" width="2" height="6"></rect>
          <rect id="Rectangle" x="0" y="7" width="2" height="2"></rect>
        </g>
      </g>
    </g>
  </g>
</svg>
